import {
    Button,
    Flex,
    Heading,
    InputGroup,
    InputRightElement,
    SimpleGrid,
    Text,
} from '@chakra-ui/react'
import { Field, Formik } from 'formik'
import { CheckboxSingleControl, InputControl } from 'formik-chakra-ui'
import { Link } from 'react-router-dom'

import { defaultBorder3 } from '../../../../../chakraTheme'
import FormikSelectInput from '../../../../../common/FormikSelectInput'
import { Cross, Tick2 } from '../../../../../components/Icons/default'
import YEAR_OF_PASSING from '../../../enums/yearOfPassing'
import { calculateDiscount } from '../_utils'
import VoucherError from './VoucherError'
import VoucherSuccess from './VoucherSuccess'

const INITIAL_VALUES = {
    firstName: '',
    lastName: '',
    email: '',
    xiiYop: '',
    state: '',
    voucherCode: '',
    isTnCAccepted: false,
}

const RegistrationForm = ({
    onSubmit,
    isDirectApplicant,
    amount,
    isOtpVerified,
    setVoucherCode,
    fetchVoucherDetails,
    voucher,
    voucherError,
    isVoucherError,
    isFetchVoucherSuccess,
    resetVoucher,
    clientType,
    isPaymentInProgress,
}) => {
    const renderFinalAmount = _voucher => {
        let finalAmount = amount

        if (_voucher) {
            finalAmount = amount - calculateDiscount(_voucher, amount)
        }
        return parseFloat(finalAmount / 100)
    }

    const textColor = isOtpVerified ? 'codgray' : 'silver2'

    return (
        <Flex pt={12} pb={180}>
            <Formik
                initialValues={INITIAL_VALUES}
                onSubmit={onSubmit}
                validate={values => {
                    const errors = {}

                    const requiredFields = [
                        'firstName',
                        'lastName',
                        'email',
                        'xiiYop',
                        'state',
                        'isTnCAccepted',
                    ]

                    if (
                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(
                            values.email
                        )
                    ) {
                        errors.email = 'Invalid email address'
                    }

                    requiredFields.forEach(field => {
                        if (!values[field]) {
                            errors[field] = 'Required'
                        }
                    })

                    return errors
                }}
                validateOnMount={true}
            >
                {({
                    values,
                    submitForm,
                    isValid,
                    handleChange,
                    setFieldValue,
                }) => (
                    <Flex as="form" flexGrow={1} flexDirection={'column'}>
                        {/* Basic Details */}
                        <Flex
                            alignItems="start"
                            flexDirection="column"
                            pb={12}
                            flexGrow={1}
                            borderBottom={defaultBorder3}
                        >
                            <SimpleGrid
                                columns={{ base: 1, md: 2 }}
                                rowGap={8}
                                columnGap={6}
                                width={'full'}
                            >
                                <InputControl
                                    name="firstName"
                                    label="First Name"
                                    isRequired
                                    inputProps={{
                                        variant: 'retro',
                                        height: '56px',
                                        isDisabled: !isOtpVerified,
                                        placeholder: 'Enter your first name',
                                    }}
                                    isDisabled={!isOtpVerified}
                                />
                                <InputControl
                                    name="lastName"
                                    label="Last Name"
                                    isRequired
                                    inputProps={{
                                        variant: 'retro',
                                        height: '56px',
                                        isDisabled: !isOtpVerified,
                                        placeholder: 'Enter your last name',
                                    }}
                                    isDisabled={!isOtpVerified}
                                />
                                <InputControl
                                    name="email"
                                    label="Email"
                                    isRequired
                                    inputProps={{
                                        variant: 'retro',
                                        height: '56px',
                                        isDisabled: !isOtpVerified,
                                        placeholder: 'Enter your email',
                                    }}
                                    inputMode={'email'}
                                    isDisabled={!isOtpVerified}
                                />
                                <Field
                                    name={'xiiYop'}
                                    component={FormikSelectInput}
                                    options={YEAR_OF_PASSING}
                                    isSearchable={false}
                                    label="12th Year of Passing"
                                    isRequired
                                    isDisabled={!isOtpVerified}
                                    placeholder="Select Year of Passing"
                                />
                                <Field
                                    name={'state'}
                                    component={FormikSelectInput}
                                    options={[
                                        {
                                            value: 'Andaman and Nicobar Islands',
                                            label: 'Andaman and Nicobar Islands',
                                        },
                                        {
                                            value: 'Andhra Pradesh',
                                            label: 'Andhra Pradesh',
                                        },
                                        {
                                            value: 'Arunachal Pradesh',
                                            label: 'Arunachal Pradesh',
                                        },
                                        { value: 'Assam', label: 'Assam' },
                                        { value: 'Bihar', label: 'Bihar' },
                                        {
                                            value: 'Chandigarh',
                                            label: 'Chandigarh',
                                        },
                                        {
                                            value: 'Chhattisgarh',
                                            label: 'Chhattisgarh',
                                        },
                                        {
                                            value: 'Dadra and Nagar Haveli',
                                            label: 'Dadra and Nagar Haveli',
                                        },
                                        {
                                            value: 'Daman and Diu',
                                            label: 'Daman and Diu',
                                        },
                                        { value: 'Delhi', label: 'Delhi' },
                                        { value: 'Goa', label: 'Goa' },
                                        { value: 'Gujarat', label: 'Gujarat' },
                                        { value: 'Haryana', label: 'Haryana' },
                                        {
                                            value: 'Himachal Pradesh',
                                            label: 'Himachal Pradesh',
                                        },
                                        {
                                            value: 'Jammu and Kashmir',
                                            label: 'Jammu and Kashmir',
                                        },
                                        {
                                            value: 'Jharkhand',
                                            label: 'Jharkhand',
                                        },
                                        {
                                            value: 'Karnataka',
                                            label: 'Karnataka',
                                        },
                                        { value: 'Kerala', label: 'Kerala' },
                                        { value: 'Ladakh', label: 'Ladakh' },
                                        {
                                            value: 'Lakshadweep',
                                            label: 'Lakshadweep',
                                        },
                                        {
                                            value: 'Madhya Pradesh',
                                            label: 'Madhya Pradesh',
                                        },
                                        {
                                            value: 'Maharashtra',
                                            label: 'Maharashtra',
                                        },
                                        { value: 'Manipur', label: 'Manipur' },
                                        {
                                            value: 'Meghalaya',
                                            label: 'Meghalaya',
                                        },
                                        { value: 'Mizoram', label: 'Mizoram' },
                                        {
                                            value: 'Nagaland',
                                            label: 'Nagaland',
                                        },
                                        { value: 'Odisha', label: 'Odisha' },
                                        {
                                            value: 'Puducherry',
                                            label: 'Puducherry',
                                        },
                                        { value: 'Punjab', label: 'Punjab' },
                                        {
                                            value: 'Rajasthan',
                                            label: 'Rajasthan',
                                        },
                                        { value: 'Sikkim', label: 'Sikkim' },
                                        {
                                            value: 'Tamil Nadu',
                                            label: 'Tamil Nadu',
                                        },
                                        {
                                            value: 'Telangana',
                                            label: 'Telangana',
                                        },
                                        { value: 'Tripura', label: 'Tripura' },
                                        {
                                            value: 'Uttar Pradesh',
                                            label: 'Uttar Pradesh',
                                        },
                                        {
                                            value: 'Uttarakhand',
                                            label: 'Uttarakhand',
                                        },
                                        {
                                            value: 'West Bengal',
                                            label: 'West Bengal',
                                        },
                                    ]}
                                    isSearchable={false}
                                    label="State"
                                    isRequired
                                    isDisabled={!isOtpVerified}
                                    placeholder="Select your state"
                                />
                            </SimpleGrid>
                        </Flex>
                        {/* Voucher Block */}
                        <Flex
                            alignItems="start"
                            flexDirection="column"
                            pt={12}
                            pb={16}
                            flexGrow={1}
                            borderBottom={'3px solid #E3E3E3'}
                        >
                            <Heading
                                as="h3"
                                fontSize="md"
                                color={isOtpVerified ? 'mineshaft' : 'silver2'}
                                display={'flex'}
                            >
                                {isDirectApplicant
                                    ? 'Application Fee'
                                    : 'Test Code'}
                                {!isDirectApplicant && (
                                    <Text
                                        color={'pomegranate'}
                                        ml={1}
                                        fontWeight={400}
                                    >
                                        *
                                    </Text>
                                )}
                            </Heading>
                            {isDirectApplicant ? (
                                <>
                                    <Text mt={6} color={textColor}>
                                        The fee to register for KNET is{' '}
                                        <b>INR 1999</b> only.
                                    </Text>
                                    <Text
                                        mt={8}
                                        fontSize={'sm'}
                                        color={textColor}
                                    >
                                        Have a coupon code? Add here
                                    </Text>
                                </>
                            ) : (
                                <Text my={6} color={textColor}>
                                    Enter the test code provided to you
                                </Text>
                            )}
                            <Flex mt={2} w="full">
                                <InputGroup maxW={320} alignItems={'center'}>
                                    <InputControl
                                        name="voucherCode"
                                        inputProps={{
                                            placeholder: isDirectApplicant
                                                ? 'Enter your coupon code'
                                                : 'Enter your test code',
                                            variant: 'retro',
                                            height: '56px',
                                            _disabled: {
                                                borderColor:
                                                    isFetchVoucherSuccess
                                                        ? 'mineshaft'
                                                        : 'silver2',
                                                color: 'silver2',
                                                cursor: 'not-allowed',
                                            },
                                            isDisabled:
                                                !isOtpVerified ||
                                                isFetchVoucherSuccess,
                                        }}
                                        flexGrow={1}
                                        maxW={320}
                                        onChange={e => {
                                            handleChange(e)
                                            setVoucherCode(e.target.value)
                                        }}
                                    />
                                    {isFetchVoucherSuccess && (
                                        <InputRightElement
                                            top={'50%'}
                                            transform={'translateY(-50%)'}
                                            cursor={'pointer'}
                                            right={27}
                                            width="unset"
                                            height="unset"
                                            onClick={() => {
                                                setFieldValue('voucherCode', '')
                                                resetVoucher()
                                            }}
                                        >
                                            <Cross
                                                color="scorpion"
                                                fontSize={'2xl'}
                                            />
                                        </InputRightElement>
                                    )}
                                </InputGroup>
                                <Button
                                    variant="pressable"
                                    px={6}
                                    py={3}
                                    height={14}
                                    isDisabled={
                                        !values.voucherCode.length ||
                                        !isOtpVerified ||
                                        isFetchVoucherSuccess
                                    }
                                    _disabled={{
                                        _active: {
                                            boxShadow: 'none',
                                        },
                                        bgColor: 'mercury !important',
                                        color: 'silver',
                                        cursor: 'not-allowed',
                                        borderColor: isOtpVerified
                                            ? 'mineshaft'
                                            : 'silver2',
                                        opacity: 1,
                                    }}
                                    borderLeft={'none'}
                                    onClick={fetchVoucherDetails}
                                >
                                    {isDirectApplicant ? 'Apply' : 'Verify'}
                                </Button>
                            </Flex>
                            <VoucherError
                                isError={isVoucherError}
                                error={voucherError}
                                clientType={clientType}
                            />
                            <VoucherSuccess
                                isSuccess={isFetchVoucherSuccess}
                                voucher={voucher}
                                clientType={clientType}
                                amount={amount}
                            />
                        </Flex>
                        {/* T&C and Register button Block */}
                        <Flex flexDirection={'column'} pt={9}>
                            <Flex>
                                <CheckboxSingleControl
                                    name="isTnCAccepted"
                                    mt={1}
                                    w={'unset'}
                                    checkBoxProps={{
                                        variant: 'retro',
                                        isDisabled: !isOtpVerified,
                                    }}
                                    errorMessageProps={{
                                        display: 'none',
                                    }}
                                />
                                <Text fontSize={'sm'} ml={4} color={textColor}>
                                    By registering for KNET&apos;24, I agree to
                                    receive my candidature-related communication
                                    via email and mobile. I also agree to the{' '}
                                    <u>
                                        <Link
                                            target="_blank"
                                            to="https://kalvium.com/terms-and-conditions/"
                                        >
                                            terms & conditions
                                        </Link>
                                    </u>{' '}
                                    that are associated with registering for KNET
                                    and acknowledge that my information will be
                                    processed in accordance with the{' '}
                                    <u>
                                        <Link
                                            target="_blank"
                                            to="https://kalvium.com/privacy-policy/"
                                        >
                                            privacy policy
                                        </Link>
                                    </u>{' '}
                                    of Kalvium.
                                </Text>
                            </Flex>
                            <Button
                                variant={'clickable'}
                                width={{
                                    base: 'full',
                                    md: 'max-content',
                                }}
                                mt={8}
                                onClick={submitForm}
                                isDisabled={
                                    !isValid ||
                                    !isOtpVerified ||
                                    (!isDirectApplicant &&
                                        !isFetchVoucherSuccess) ||
                                    isPaymentInProgress
                                }
                            >
                                <Tick2 />
                                {isDirectApplicant ? (
                                    <Text ml={3}>
                                        Pay ₹ {renderFinalAmount(voucher)} &
                                        Register
                                    </Text>
                                ) : (
                                    <Text ml={3}>Register</Text>
                                )}
                            </Button>
                        </Flex>
                    </Flex>
                )}
            </Formik>
        </Flex>
    )
}

export default RegistrationForm
